
import { useState, useEffect } from "react";
import { SecurityLog } from "@/types/security";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/components/ui/use-toast";
import { getSecurityLogs } from "@/services/securityLogService";

interface SecurityLogsFilters {
  actionType: string;
  userId: string;
  dateFrom?: Date;
  dateTo?: Date;
}

export const useSecurityLogs = (filters: SecurityLogsFilters) => {
  const [logs, setLogs] = useState<SecurityLog[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user, hasRole } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    const fetchLogs = async () => {
      setIsLoading(true);
      try {
        // Only admins can see all logs
        if (!user) {
          setLogs([]);
          return;
        }
        
        const isAdmin = hasRole('admin');
        
        // If not admin, filter logs by user ID
        const fetchFilters = {
          ...filters,
          userId: isAdmin ? filters.userId : user.id, // Non-admins can only see their own logs
        };
        
        const securityLogs = await getSecurityLogs(fetchFilters);
        // Make sure the returned logs match the SecurityLog type
        setLogs(securityLogs as SecurityLog[]);
      } catch (error) {
        console.error("Error fetching security logs:", error);
        toast({
          title: "Erro",
          description: "Não foi possível carregar os logs de segurança.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (user) {
      fetchLogs();
    } else {
      setLogs([]);
      setIsLoading(false);
    }
  }, [user, filters, toast, hasRole]);

  return { logs, isLoading };
};
